import Request from 'src/utils/request'

/**
 * 修改初始密码
 * @returns
 */
export function changePasswordApi (data) {
  return Request({
    url: '/user/update_init_password',
    method: 'post',
    data,
  })
}

/**
 * 获取大屏下拉数据
 * @returns
 */
export function getScreenListApi (data) {
  return Request({
    url: '/panel/selector',
  })
}

/**
 * 保存数据大屏
 * @returns
 */
export function saveScreenApi (data) {
  return Request({
    url: '/panel',
    method: 'post',
    data,
  })
}
